module.exports = __webpack_public_path__ + "static/img/yytx18.ed5a313.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx18.png
// module id = 798
// module chunks = 0